import { render, staticRenderFns } from "./modal-plan-copy.vue?vue&type=template&id=4e613196&"
import script from "./modal-plan-copy.vue?vue&type=script&setup=true&lang=js&"
export * from "./modal-plan-copy.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports